/*
  Guide-Artikel: Die Sprungmarken rendert main-article-guide.liquid serverseitig (kein Layout-Shift).
  Dieses Script markiert nur die aktive Section (aria-current) und scrollt die Leiste mobil mit.
*/
(function () {
  function init() {
    var nav = document.querySelector('.guide-nav');
    var list = nav && nav.querySelector('.guide-nav__list');
    if (!nav || !list) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('.guide-nav__link'));
    var sections = links.map(function (link) {
      return document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1)));
    });
    if (!('IntersectionObserver' in window)) return;
    var current = null;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var idx = sections.indexOf(entry.target);
        if (idx === -1 || current === idx) return;
        current = idx;
        links.forEach(function (link, i) {
          if (i === idx) {
            link.setAttribute('aria-current', 'true');
            if (list.scrollTo && window.matchMedia('(max-width: 999px)').matches) {
              list.scrollTo({ left: link.parentNode.offsetLeft - 16, behavior: 'smooth' });
            }
          } else {
            link.removeAttribute('aria-current');
          }
        });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    sections.forEach(function (s) { if (s) observer.observe(s); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
